(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5649],{

/***/ 95649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content005": function() { return /* binding */ Content005; },
  "default": function() { return /* binding */ Content005_Content005; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./src/components/widgets/content/Content005/Content005.module.scss
var Content005_module = __webpack_require__(42280);
var Content005_module_default = /*#__PURE__*/__webpack_require__.n(Content005_module);
// EXTERNAL MODULE: ./src/shared/hooks/index.js + 6 modules
var hooks = __webpack_require__(87367);
// EXTERNAL MODULE: ./src/shared/utils/index.js + 10 modules
var utils = __webpack_require__(63414);
// EXTERNAL MODULE: ./src/components/widgets/content/Content005/MediaItem/MediaItem.module.scss
var MediaItem_module = __webpack_require__(62298);
var MediaItem_module_default = /*#__PURE__*/__webpack_require__.n(MediaItem_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content005/MediaItem/MediaItem.jsx





var MediaItem = function(param) {
    var videoLink = param.videoLink, image = param.image;
    var videoId = (0,utils/* parseYouTubeId */.Us)(videoLink);
    var ref = (0,hooks/* useToggle */.OT)(), opened = ref.opened, onOpen = ref.onOpen, onClose = ref.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (MediaItem_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageLite */.NH, {
                image: image,
                className: (MediaItem_module_default()).image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MediaItem_module_default()).content,
                children: [
                    videoId && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Action */.aU, {
                        onClick: onOpen,
                        className: (MediaItem_module_default()).play,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                            name: "play",
                            theme: "white"
                        })
                    }),
                    opened && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ModalWrapper */.AB, {
                        onCloseModal: onClose,
                        appearance: "full-area",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* YoutubeVideo */.tL, {
                            id: videoId
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content005/MediaItem/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content005/Content005.jsx







var Content005 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var facts = (ref1 = payload === null || payload === void 0 ? void 0 : payload.facts) !== null && ref1 !== void 0 ? ref1 : [];
    var ref2;
    var gallery = (ref2 = payload === null || payload === void 0 ? void 0 : payload.gallery) !== null && ref2 !== void 0 ? ref2 : [];
    var filteredGallery = gallery.filter(function(item) {
        return Boolean(item.image);
    });
    var formatCounter = function(number) {
        return number > 9 ? number : "0".concat(number);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Content005_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Container */.W2, {
            className: (Content005_module_default()).inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Content005_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                            as: "h2",
                            className: (Content005_module_default()).title,
                            appearance: "bold",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                            className: (Content005_module_default()).list,
                            children: facts.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: (Content005_module_default())["list-item"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading6 */.Cd, {
                                            color: "brand",
                                            as: "span",
                                            plain: true,
                                            children: formatCounter(index + 1)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading6 */.Cd, {
                                            as: "p",
                                            children: item.title
                                        })
                                    ]
                                }, item.id);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Content005_module_default()).media,
                    children: filteredGallery.map(function(item) {
                        return /*#__PURE__*/ (0,react.createElement)(MediaItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                            key: item.id
                        }));
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Content005_Content005 = (Content005);


/***/ }),

/***/ 42280:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content005_wrapper__qeG_X","inner":"Content005_inner___bwCE","content":"Content005_content__H8Fud","media":"Content005_media__GgA1a","title":"Content005_title__1uPDb","list":"Content005_list__cXRYn","list-item":"Content005_list-item__J0j1S"};

/***/ }),

/***/ 62298:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MediaItem_wrapper__djkpo","play":"MediaItem_play__Qvi0M","content":"MediaItem_content__YOdiP","image":"MediaItem_image__f6TWL","video-wrapper":"MediaItem_video-wrapper__xvOoq","video":"MediaItem_video__oasBh","close":"MediaItem_close__k5hzy","close-icon":"MediaItem_close-icon__POIMT"};

/***/ })

}]);